import React, { Component } from "react";

import MatButton from "@mui/material/Button";

import blobToBuffer from "blob-to-buffer";
import Recorder from "./controllerAudio";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default class Mp3Recorder extends Component {
  state = {
    inicioGravacao: 0,
    gravador: undefined,
    gravandoAudio: false,
    audioGravado: undefined,
    blobURL: null,
    url: "",
    gravou: false,
  };

  descartar = () => {
    this.props.getAudio(undefined);
    // _cleanup();

    this.setState({ gravador: undefined, gravandoAudio: false, blobURL: null });
  };

  _onRecordingComplete = (blob, startGravar) => {
    // console.log("mp3");
    // console.log("blob", blob);
    // console.log("startGravar", startGravar);

    // blobToBuffer(blob, (err, buffer) => {
    // console.log("blob", blob);

    const fimGravacao = new Date().getTime();

    const tempoAudio = Math.round((fimGravacao - startGravar) / 1000);
    // console.log("fimGravacao", fimGravacao);

    // if (err) {
    //   console.error(err);
    //   return;
    // }

    if (this.state.url) {
      window.URL.revokeObjectURL(this.state.url);
    }

    const blobURL = window.URL.createObjectURL(blob);

    this.props.getAudio(blob, blobURL, tempoAudio);

    // console.log("blob:", blob);
    // console.log("blobURL", blobURL);

    this.setState({
      url: window.URL.createObjectURL(blob),
      gravador: undefined,
      blobURL,
      tempoAudio,
      gravou: true,
    });
    // });
  };

  _onRecordingError = (err) => {
    // console.log("error recording", err);

    if (this.state.url) {
      window.URL.revokeObjectURL(this.state.url);
    }

    this.setState({ url: null });
  };
  render() {
    const { url } = this.state;
    // console.log("recordedAudio", this.props.recordedAudio);

    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {this.props.recordedAudio && <audio src={url} controls />}

          <div style={{ display: "inline" }}>
            <Recorder
              onRecordingComplete={this._onRecordingComplete}
              onRecordingError={this._onRecordingError}
              _cleanup={this.descartar}
              style={{
                margin: "0 auto",
              }}
            />
          </div>

          {/* {this.props.recordedAudio && <audio src={url} controls />} */}

          {/* {this.props.recordedAudio && (
          <IconButton
            onClick={() => {
              setAudioPronto(false);
              setGravando(false);
            }}
          >
            <DeleteIcon></DeleteIcon>
          </IconButton>
          // <MatButton
          //   mini
          //   className="btn-warning text-white mr-15 top"
          //   onClick={this.descartar}
          //   type="button"
          // >
          //   <i className="zmdi zmdi-delete" style={{ fontSize: 20 }}></i>
          // </MatButton>
        )} */}
        </div>
      </div>
    );
  }
}
